<template>
    <div id="app">
        <link rel="stylesheet" href="//fonts.googleapis.com/icon?family=Material+Icons">
        <router-view/>
    </div>
</template>
<script>
export default {
  name: 'app'
};
</script>
<style type="text/scss">
input {
    border-left: none;
    border-top: none;
    border-right: none;
}

body {
    font: 14px/20px 'Roboto', sans-serif !important;
}

*:focus {
    outline: none;
}

.md-button.md-primary {
    color: white !important;
}

.md-button.md-primary i {
    color: white !important;
}

.md-button.md-theme-default.md-fab:not([disabled]).md-primary {
    background-color: #00A8CA !important;
}

.md-button.md-theme-default.md-raised:not([disabled]).md-primary {
    background-color: #00A8CA !important;
}

.btn-danger {
    background-color: #d9534f !important;
    border-color: #d43f3a !important;
}

.md-checkbox.md-theme-default.md-checked .md-checkbox-container {
    background-color: #00A8CA !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue